import React, {useMemo, useState} from "react";
import {PersistentStateId} from "../../../../../../store/common/Grid";
import {DiagramInfoDto} from "../../../../../../common/apis/diagram/DiagramInfoDto";
import {GridAction} from "../../../../../../components/grid/GridAction";
import {createDiagramPanelColDef} from "./DiagramsPanelColumnDefinition";
import {_transl} from "../../../../../../store/localization/TranslMessasge";
import constructDiagramController from "../../../diagrams/controller/DiagramController";
import DiagramDetailDialog from "../../../diagrams/detail/DiagramDetailDialog";
import ExtGridWrapper from "../../../../../../components/grid/ExtGridWrapper";
import {useSelector} from "react-redux";
import {IApplicationState} from "../../../../../../store/Store";


interface DiagramPanelProps {
    diagrams: DiagramInfoDto[],
    elementId: string,
}

export default function DiagramsPanel({diagrams, elementId}: DiagramPanelProps) {

    const controller = useMemo(() => constructDiagramController(), []);

    const selectedRowIds = useSelector((state: IApplicationState) =>
        state.pages.gridPersistentState[PersistentStateId.DIAGRAMS_CONTAINING_ITEM_GRID]?.selectedRowIds || []
    );
    const selectedDiagramId = selectedRowIds.length > 0 ? selectedRowIds[0] as string : undefined;

    const [diagramDetailDialogOpened, setDiagramDetailDialogOpened] = useState<boolean>(false);

    return (
        <React.Fragment>
            {selectedDiagramId && diagramDetailDialogOpened &&
                <DiagramDetailDialog opened={true}
                                     diagramId={selectedDiagramId}
                                     onClosed={() => setDiagramDetailDialogOpened(false)}
                />
            }
            <ExtGridWrapper
                columns={createDiagramPanelColDef(_transl)}
                rows={diagrams}
                rowCount={diagrams.length}
                getRowId={row => row.identifier}
                actions={[
                    GridAction.detailButtonBuilder()
                        .onClick(() => {
                            setDiagramDetailDialogOpened(true);
                        }).build(),
                    GridAction.showDiagramEditorButtonBuilder(false).build(),
                    GridAction.showDiagramEditorButtonBuilder(true)
                        .isEnabled(selectedRows => controller.canUpdateAllDiagrams(selectedRows))
                        .build(),
                ]}
                peristentStateId={PersistentStateId.DIAGRAMS_CONTAINING_ITEM_GRID}
                resourceId={elementId}
            />
        </React.Fragment>
    );
}
